import { SeriesLineOptions, SeriesOptions } from 'highcharts/highstock';
import { DeviceConsumptionResult } from 'types';
import { convertConsumptionTime, sortSeries } from '../general';

export const addTempSeries = (
    series: SeriesOptions[],
    consumption: DeviceConsumptionResult
) => {
    const tempData = [];
    for (const readingId in consumption) {
        const reading = consumption[readingId];
        const date = convertConsumptionTime(readingId);
        if (
            (!!reading.consumption || reading.consumption === 0) &&
            reading.temp
        )
            tempData.push([date, reading.temp]);
    }
    const tempSeries: SeriesLineOptions = {
        id: 'min_temp',
        type: 'line',
        color: '#555555',
        yAxis: 4,
        name: 'min temp',
        dataGrouping: { enabled: false },
        data: sortSeries(tempData),
        tooltip: {
            valueSuffix: '°F',
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        },
    };
    series.push(tempSeries);
};
